import React from "react";
import ReactDOM from "react-dom";
import App from "@root/App";
import "@root/tailwind.css";

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
);
